import BulkImportStakeholdersModal from './bulk-import-stakeholders-modal';

export default BulkImportStakeholdersModal;
